import React from "react";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import ErrorIcon from "@material-ui/icons/Error";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import EmpaqueIcon from "./EmpaqueIcon";
import ListoParaEntregarIcon from "./ListoParaEntregarIcon";

export const ESTADOS_TICKET = {
  recibido: {
    value: 1,
    label: "Recibido",
    icon: (props = {}) => <MonetizationOnIcon {...props} />
  },
  enEmpaque: { value: 2, label: "En empaque", icon: (props = {}) => <EmpaqueIcon {...props} /> },
  listoParaEntregar: {
    value: 3,
    label: "Listo para entregar",
    icon: (props = {}) => <ListoParaEntregarIcon {...props} />
  },
  enEntrega: {
    value: 4,
    label: "En entrega",
    icon: (props = {}) => <LocalShippingIcon {...props} />
  },
  pedidoConIncidente: {
    value: 5,
    label: "Pedido con incidente",
    icon: (props = {}) => <ErrorIcon {...props} />
  },
  entregado: { value: 6, label: "Entregado", icon: (props = {}) => <DoneIcon {...props} /> },
  abandonado: {
    value: 7,
    label: "Abandonado",
    icon: (props = {}) => <AccessTimeIcon {...props} />
  },
  cancelado: { value: 8, label: "Cancelado", icon: (props = {}) => <ClearIcon {...props} /> }
};

export const tiposTicket = {
  ventas: {
    value: "ventas",
    filtros: {
      recibidos: [
        {
          ...ESTADOS_TICKET.recibido,
          label: "Recibidos"
        },
        {
          ...ESTADOS_TICKET.enEmpaque
        },
        {
          ...ESTADOS_TICKET.listoParaEntregar,
          label: "Listos para entregar"
        },
        {
          ...ESTADOS_TICKET.enEntrega
        },
        {
          ...ESTADOS_TICKET.pedidoConIncidente,
          label: "Pedidos con incidente"
        }
      ],
      abandonados: [
        {
          ...ESTADOS_TICKET.abandonado,
          label: "Abandonados"
        }
      ],
      archivados: [
        {
          ...ESTADOS_TICKET.entregado,
          label: "Entregados"
        },
        {
          ...ESTADOS_TICKET.cancelado,
          label: "Cancelados"
        }
      ]
    }
  }
};

export const DELIVERY_OPTIONS = {
  none: "none",
  delivery: "delivery",
  convenience: "convenience",
  pickup: "pickup"
};

export const PAYMENT_OPTIONS = {
  webpay: { str: "webpay-plus", int: 1 },
  onepay: { str: "onepay", int: 5 },
  transferencia: { str: "transferencia", int: 10 }
};
